export default __webpack_public_path__ + "static/media/store-umbrella.eb5ce5f3.png";